/* eslint-disable @typescript-eslint/no-explicit-any */

// LT-1564: ride-manager returns 409 with { codeError: "DUPLICATE_RIDE" } when an
// identical booking already exists. Axios rejects on 409, so we read the body off the error.
export function isDuplicateRideError(error: any): boolean {
    return error?.response?.data?.codeError === 'DUPLICATE_RIDE';
}
